import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/replyd': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M320 480h-192c-70.4 0-128-57.6-128-128v-192c0-70.4 57.6-128 128-128h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1zM308.6 376.6c-3.2 2.4-7.7 4.8-13.7 7.1s-12.8 3.5-20.4 3.5c-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c0.9-4.8 1.6-9.4 2.1-13.9 0.5-4.4 0.7-8.6 0.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2zM286.8 306.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c0.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-0.1 14.1 2.6 17.9 8zM366.7 308.8c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8 4.1-3.9 6.1-9.1 6.1-15.6s-2-11.6-6.1-15.4-9.6-5.7-16.7-5.7c-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zM366.7 409.3c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8 4.1-3.9 6.1-9.1 6.1-15.6s-2-11.6-6.1-15.4-9.6-5.7-16.7-5.7c-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/replyd.js
// module id = 996
// module chunks = 0